var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 7.67501C11.4024 7.67501 7.6752 11.4022 7.6752 16C7.6752 20.5978 11.4024 24.325 16.0002 24.325C20.598 24.325 24.3252 20.5978 24.3252 16C24.3252 11.4022 20.598 7.67501 16.0002 7.67501ZM6.3252 16C6.3252 10.6567 10.6568 6.32501 16.0002 6.32501C21.3436 6.32501 25.6752 10.6567 25.6752 16C25.6752 21.3434 21.3436 25.675 16.0002 25.675C10.6568 25.675 6.3252 21.3434 6.3252 16Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5752 15.25C14.5752 14.8772 14.8774 14.575 15.2502 14.575H16.0002C16.373 14.575 16.6752 14.8772 16.6752 15.25V19.825H16.7502C17.123 19.825 17.4252 20.1272 17.4252 20.5C17.4252 20.8728 17.123 21.175 16.7502 21.175H16.0002C15.6274 21.175 15.3252 20.8728 15.3252 20.5V15.925H15.2502C14.8774 15.925 14.5752 15.6228 14.5752 15.25Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C16.6213 13 17.125 12.4963 17.125 11.875C17.125 11.2537 16.6213 10.75 16 10.75C15.3787 10.75 14.875 11.2537 14.875 11.875C14.875 12.4963 15.3787 13 16 13Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f84cc58c665d9f11803e4463e1fa30bd.svg";
export { ForwardRef as ReactComponent };